import { Printer, CheckCircle2 } from "lucide-react";

const STEPS = [
  { phase: "1 · Booking Comes In", color: "#F2B705", items: [
    "Customer submits a booking (online wizard or you create a Manual Booking).",
    "It appears under Bookings with status NEW. Confirm the requested car is available for those dates/times (the wizard blocks overlaps, but double-check).",
    "Reminder: 3-day minimum rental. No out-of-town trips — all rentals stay within the St. Louis metro area.",
  ]},
  { phase: "2 · Verify the Renter", color: "#F2B705", items: [
    "Open the booking and review the uploaded driver's license (front/back) and selfie.",
    "Run AI Address Check — confirm the license address matches.",
    "If they chose 'Bring Your Own Insurance', collect their insurance card and run the AI Insurance Check (watch for expired / name mismatch). If 'bring at pickup', flag it.",
    "Check the customer isn't on the Do-Not-Rent list (Customers tab).",
  ]},
  { phase: "3 · Approve & Agreement", color: "#F2B705", items: [
    "Click 'Approve & Generate Agreement' — enter the rate, fees, discount and any amount paid.",
    "This emails + texts the customer their signing link automatically. Booking status moves to CONFIRMED.",
  ]},
  { phase: "4 · Signature", color: "#34d399", items: [
    "Customer opens the link and e-signs (you'll see it flip to Signed; rental auto-moves to ACTIVE).",
    "If they're in person, have them sign the hard copy and click 'Mark as Signed (hard copy)' on the Agreements tab.",
    "Optionally use 'Save card on file' so tolls/damage can be charged later.",
  ]},
  { phase: "5 · Pre-Trip Inspection (at pickup)", color: "#34d399", items: [
    "Before handing over keys, open the booking's Inspection panel (or Inspections tab).",
    "Take Pre-Trip photos: walk around the EXTERIOR (all sides, existing scratches/dents) and the INTERIOR.",
    "Record the odometer mileage and fuel level. Add notes for any existing damage.",
    "Click Save, then 'Email' the condition report to the customer so the pickup condition is documented in writing.",
  ]},
  { phase: "6 · Hand Over the Keys", color: "#34d399", items: [
    "Confirm insurance/payment is settled. Use the dropdown to set the booking to ACTIVE (OUT) if not already.",
    "Give the customer the keys and the return date/time. Drive Today. Pay Less. Stay Moving.",
  ]},
  { phase: "7 · During the Rental", color: "#38bdf8", items: [
    "Watch the Operations dashboard 'Action Needed' list for due/overdue returns.",
    "If the car needs service, use Swap Car (moves it to maintenance and texts the mechanic).",
    "Need more days? Use Extend Rental on the booking.",
  ]},
  { phase: "8 · Return & Post-Trip Inspection", color: "#38bdf8", items: [
    "On return, open the Inspection panel and do the Post-Trip inspection — photos, mileage, fuel level, notes.",
    "Compare against the pre-trip photos to spot NEW damage. If there's damage, document it and charge the card on file if needed.",
  ]},
  { phase: "9 · Close It Out", color: "#38bdf8", items: [
    "Click 'Mark Returned' (frees the car for same-day rebooking and emails a review request).",
    "Set the booking status to RETURNED → CLOSED.",
    "Log any expenses (fuel, cleaning, repairs) in the Tax / P&L tab with the receipt.",
  ]},
];

export default function CheckoutPlaybook() {
  return (
    <div className="space-y-5" data-testid="checkout-playbook">
      <div className="flex items-center justify-between print:hidden">
        <div>
          <h2 className="text-xl font-bold text-white">Employee Checkout Playbook</h2>
          <p className="text-white/50 text-sm">Step-by-step, from booking to keys to return. Print this for the desk.</p>
        </div>
        <button data-testid="playbook-print-btn" onClick={() => window.print()}
          className="flex items-center gap-2 px-4 py-2 rounded-md bg-[#F2B705] text-black text-sm font-bold hover:bg-white transition-colors">
          <Printer size={15} /> Print
        </button>
      </div>

      <div className="space-y-4">
        {STEPS.map((s) => (
          <div key={s.phase} className="rounded-xl bg-[#0C0C0C] border border-white/10 p-5 break-inside-avoid">
            <h3 className="font-display font-bold text-lg mb-3" style={{ color: s.color }}>{s.phase}</h3>
            <ul className="space-y-2">
              {s.items.map((it, i) => (
                <li key={i} className="flex items-start gap-2.5 text-sm text-white/75">
                  <CheckCircle2 size={15} className="mt-0.5 shrink-0" style={{ color: s.color }} />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
